import { RegisterEmailTranslations } from "#i18n/translations/pt-BR/recovery/register-email";

export const REGISTER_EMAIL_ES_ES: RegisterEmailTranslations = {
	registerEmail: "Registra un correo electrónico para continuar",
	cardInfo: `Te enviaremos un enlace para autenticar este correo electrónico y, después de eso, podrás acceder 
	normalmente con tu nombre de usuario y contraseña.`,
	description: "Es rápido y se hará una sola vez.",
	enterprise: "Empresa",
	email: "Correo electrónico",
	emailPlaceholder: "Ingresa tu correo electrónico",
	enterprisePlaceholder: "Ingresa tu empresa",
	login: "Nombre de usuario",
	password: "Contraseña",
	confirmPassword: "Confirmar contraseña",
	confirm: "Confirmar y enviar correo electrónico",
	send: "Enviar",
	backToLogin: "Volver al Login",
	sendEmailModal: {
		title: "Correo electrónico enviado!",
		subtitle1: "Enviamos un enlace a {{email}}",
		subtitle2: `Abre el correo electrónico y haz clic en 'Autenticar correo electrónico' para continuar 
			accediendo al Dashboard.`,
	},
	emailConfirmedModal: {
		title: "El correo electrónico que registraste ha sido autenticado!",
		subtitle:
			"Ahora podrás acceder al Dashboard Zig con tu Login y contraseña normalmente.",
		makeLogin: "Hacer login",
	},
	expiredLinkModal: {
		title: "El enlace ha expirado!",
		subtitle:
			"Ingresa el correo electrónico nuevamente para enviar un nuevo enlace de autenticación.",
		registerEmail: "Registrar correo electrónico",
	},
	resendEmail: "Reenviar correo electrónico en ({{countDown}})",
};
